import axios, { AxiosError } from 'axios';

interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});


export const get_all_userbusinesses = async (
  page: number = 1,
  limit: number = 20,
  search: string = ""
) => {
  try {
    const response = await backendAPI.get(
      `businesses/all/user_businesses?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
    );
    return response;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Failed to fetch businesses");
  }
};



export const get_business_types = async () => {
  try {
    const response = await backendAPI.get(`businesses/types`); // Adjust the endpoint URL
    return response.data;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get businesses types failed');
  }
};

export const get_businesstype_todo = async (economicActivity: string, name: string, description: string) => {
  try {

    const response = await backendAPI.get('businesses/generate_business_todo', {
      params: { economicActivity, name, description }
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message ||
      'Get business completion failed'
    );
  }
};